import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { PageHeader } from "@/components/Layout";
import { MessageSquareText, Library, BarChart3 } from "lucide-react";
import SbChat from "./SbChat";
import SbLibrary from "./SbLibrary";
import SbInsights from "./SbInsights";

export default function SecondBrain() {
  const { user } = useAuth();
  const canManage = ["Admin", "Manager"].includes(user?.role);
  const tabs = [
    { key: "ask", label: "Ask", icon: MessageSquareText, show: true },
    { key: "library", label: "Library", icon: Library, show: canManage },
    { key: "insights", label: "Insights", icon: BarChart3, show: canManage },
  ].filter((t) => t.show);
  const [tab, setTab] = useState("ask");

  return (
    <div className="flex flex-col h-screen md:h-screen" data-testid="second-brain-page">
      <PageHeader
        title="Second Brain"
        subtitle="Institutional Memory"
        action={
          tabs.length > 1 && (
            <div className="flex items-center gap-1 bg-slate-100 rounded-md p-1" data-testid="sb-tabs">
              {tabs.map(({ key, label, icon: Icon }) => (
                <button
                  key={key}
                  onClick={() => setTab(key)}
                  data-testid={`sb-tab-${key}`}
                  className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-sm transition-colors ${
                    tab === key ? "bg-white text-[#0a2540] shadow-sm" : "text-slate-500 hover:text-slate-800"
                  }`}
                >
                  <Icon size={13} />
                  {label}
                </button>
              ))}
            </div>
          )
        }
      />
      <div className="flex-1 min-h-0 overflow-hidden">
        {tab === "ask" && <SbChat />}
        {tab === "library" && canManage && <SbLibrary />}
        {tab === "insights" && canManage && <SbInsights />}
      </div>
    </div>
  );
}
